export default class StepController {
  constructor(resource) {
    this._resource = resource;
  }

  recurrencyConsultingByTransactionId(transactionId) {
    return this._resource(`transactions/recurrencyConsulting`)
      .get({ transactionId })
      .then(res => res.data);
  }

  getPendingTransactions() {
    return this._resource(`transactions/pending`)
      .get()
      .then(res => res.data);
  }

  async updatePendingTransactionsPaidWithPIX(transactionId, description) {
    try {
      const response = await this._resource(
        `transactions/pending/${transactionId}`
      ).save(description);

      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  captureTransaction(data) {
    return this._resource('transaction/capture-transaction')
      .save(data)
      .then(res => res.data);
  }

  async cancelMulctBreakdown(transactionId, motive, password) {
    try {
      const { body } = await this._resource(`transactions/cancel-mulct-breakdown-transaction/${transactionId}`)
        .save({
          motive,
          password
        });
        return body;      
    } catch (error) {
      return {
        ok: false,
        message: 'A senha informada não tem permissão para realizar essa ação.',
      };
    }
  }

  getMulctsAndBreakdownsPending() {
    return this._resource(`transactions/mulct-pending`)
      .get()
      .then(res => res.data);
  }

  postMulctsAndBreakdownsPending(data) {
    return this._resource('transaction/mulct-pending')
      .save(data)
      .then(res => res.data);
  }

  finishMulct(data) {
    return this._resource('transaction/mulct-finish')
      .save(data)
      .then(res => res.data);
  }

  getPaidPixTransactions() {
    return this._resource('transactions/pix')
      .get()
      .then(res => res.data);
  }

  async getDetailedBillingReport(beginDate, endDate) {
    try {
      let response = await this._resource(
        'transactions/detailed-billing-report'
      ).get({
        start_date: beginDate,
        end_date: endDate,
      });
      return response;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async getMonthlyDetailedBillingReport(beginDate, endDate) {
    try {
      let response = await this._resource(
        'transactions/monthly-detailed-billing-report'
      ).get({
        start_date: beginDate,
        end_date: endDate,
      });
      return response;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }
}
